/**
 * Afterlife: уже виденная вилка ушла ниже пола публикации, но ноги живы.
 * В общем кадре её нет. У работы (`held`) — есть, и цифры едут.
 *
 * Поле `al` аддитивное: старый бандл его не знает и просто рисует строку.
 */

import type { Fork } from '../lib/protocol';

export function isAfterlife(fork: Fork): boolean {
  return fork.al === true;
}

/** Соседям afterlife не показывают. Работе — показывают. */
export function afterlifeVisible(id: string, fork: Fork, held: ReadonlySet<string>): boolean {
  return !isAfterlife(fork) || held.has(id);
}
